module.exports = __webpack_public_path__ + "static/media/file-powerpoint.eebefecb.svg";